var _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisaLogos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 32,
    viewBox: "0 0 192 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_13333)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5173 20.3196C49.4373 20.7996 49.3573 21.2796 49.2773 21.7595C48.7973 21.5996 48.3173 21.3596 47.5974 21.4396C47.1974 21.4396 46.6374 21.5996 46.6374 21.9995C46.6374 22.3995 47.3574 22.6395 47.7574 22.8795C48.4773 23.1995 49.1973 23.6794 49.2773 24.5594C49.3573 25.2794 48.9573 25.8393 48.6373 26.1593C47.6774 27.0393 45.4375 27.1992 43.9176 26.5593C43.9976 26.0793 44.0776 25.5993 44.1576 25.0394C44.7175 25.2793 45.5175 25.5993 46.3974 25.5193C46.7974 25.4393 47.2774 25.2794 47.2774 24.8794C47.2774 24.3994 46.3174 24.0794 45.8375 23.8394C45.2775 23.5194 44.6375 23.0395 44.6375 22.3195C44.6375 21.8395 44.7975 21.3596 45.0375 21.0396C45.8375 20.1596 47.8374 19.8397 49.5173 20.3196Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5982 10.7998H33.5981L32.3982 18.3994H30.3983L31.5982 10.7998Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6386 10.7998H27.6785C29.5983 10.7998 30.1583 11.9197 29.9183 13.1997C29.7583 14.3196 28.9584 15.0396 27.9184 15.2796L29.8383 18.3994H27.2785L25.8386 15.4395L25.4386 18.3994H23.4387L24.6386 10.7998ZM26.3985 12.3197L26.0785 14.2396H26.6385C27.1985 14.2396 27.7584 13.8396 27.8384 13.2797C27.9184 12.7197 27.5185 12.3197 26.9585 12.3197H26.3985Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7977 10.7998H42.7976L41.5977 18.3994H39.5978L40.7977 10.7998Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3175 10.7998H48.7173L48.4773 12.4797H46.0774L45.8375 13.7596H48.1573L47.9173 15.4395H45.5975L45.3575 16.7995H47.7574L47.5174 18.3994H43.1176L44.3175 10.7998Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0389 10.7998H23.4386L23.1987 12.4797H20.7988L20.5588 13.7596H22.8787L22.6387 15.4395H20.3188L20.0788 16.7995H22.4787L22.2387 18.3994H17.839L19.0389 10.7998Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.118 10.7998H39.5978L39.3578 12.4797H36.8779L36.6379 13.7596H38.8778L38.6378 15.4395H36.398L35.918 18.3994H33.9181L35.118 10.7998Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9172 10.7998H52.5571C55.6769 10.7998 56.3969 13.1197 56.1569 14.6396C55.8369 16.7995 53.837 18.4794 51.3571 18.4794H48.7173L49.9172 10.7998ZM51.6771 12.4797H52.0771C53.597 12.4797 54.237 13.5197 54.077 14.5596C53.837 15.9195 52.7971 16.7995 51.5171 16.7995H50.9572L51.6771 12.4797Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5994 9.75983H13.3592L13.8392 15.2795C16.239 11.1198 18.7189 7.11998 21.2787 3.2002H22.4787C19.8388 8.23991 17.199 13.2796 14.6391 18.3993H11.8393L11.1993 12.3197C11.0393 10.7998 10.7193 10.1598 9.5994 9.99981V9.75983Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0394 6.64038L14.2392 7.92031L14.4792 11.3601H14.7192L17.599 6.56038V6.40039H11.0394V6.64038Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6785 23.9191C26.1585 23.9191 26.4785 24.319 26.3985 24.879C26.3185 25.439 25.8385 25.8389 25.3586 25.8389C24.8786 25.8389 24.5586 25.439 24.6386 24.879C24.7186 24.319 25.1986 23.9191 25.6785 23.9191ZM24.0786 20.2393H25.3586L24.8786 23.1991C25.2786 22.8791 25.6785 22.6391 26.2385 22.6391C27.2785 22.6391 27.9984 23.5991 27.7584 24.799C27.5984 25.9989 26.5585 26.9589 25.5186 26.9589C25.0386 26.9589 24.6386 26.7189 24.3986 26.3189L24.3186 26.7989H23.0387L24.0786 20.2393Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9184 22.7188H29.5183L30.2383 24.8786L31.5982 22.7188H33.1181L29.1184 28.9584H27.5984L29.2784 26.3185L27.9184 22.7188Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7977 26.8788L41.9176 20.1592H43.7575L42.6376 26.8788H40.7977Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1978 20.1592C38.5578 21.6791 37.9979 23.199 37.3579 24.7189L37.1979 23.839V23.999C37.0379 23.519 36.7979 23.119 36.478 22.719C36.398 22.639 36.398 22.559 36.318 22.479C36.318 22.3991 36.238 22.3991 36.238 22.3191C35.758 21.8391 35.198 21.4391 34.6381 21.1191L36.318 26.8788H38.3179C39.2778 24.6389 40.3177 22.3991 41.1977 20.1592H39.1978Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.678 20.1592H32.6382V20.3192C34.3981 20.6392 36.6379 22.0791 37.1979 23.999L36.5579 20.8791C36.4779 20.3992 36.078 20.1592 35.678 20.1592Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7569 26.9589H54.077C53.997 26.6389 53.917 26.2389 53.837 25.9189H51.5172L51.1172 26.9589H49.1173L51.6772 21.1992C51.7572 20.9592 51.9971 20.6392 52.0771 20.4792C52.2371 20.2393 52.7171 20.2393 52.9571 20.2393H54.397L55.7569 26.9589ZM52.9571 22.0792L51.9971 24.559H53.5171L52.9571 22.0792Z",
    fill: "#9F72DC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_95_13333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.171 28.4295H124.82L128.792 3.64941H135.142L131.171 28.4295Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.192 4.25518C152.939 3.75379 150.953 3.2002 148.496 3.2002C142.225 3.2002 137.808 6.57433 137.781 11.3983C137.729 14.9575 140.943 16.9343 143.347 18.121C145.804 19.3337 146.639 20.1252 146.639 21.2061C146.614 22.8662 144.654 23.6314 142.825 23.6314C140.29 23.6314 138.931 23.2369 136.867 22.3133L136.031 21.9174L135.142 27.4799C136.631 28.1646 139.376 28.7721 142.225 28.7988C148.888 28.7988 153.226 25.4768 153.278 20.3361C153.303 17.5152 151.606 15.3537 147.947 13.5875C145.726 12.4537 144.366 11.6891 144.366 10.529C144.392 9.4744 145.516 8.39419 148.023 8.39419C150.088 8.34128 151.605 8.84197 152.754 9.34301L153.328 9.60614L154.192 4.25518Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.632 19.6508C163.155 18.2272 165.168 12.7175 165.168 12.7175C165.142 12.7704 165.69 11.2677 166.003 10.3451L166.447 12.4803C166.447 12.4803 167.65 18.4119 167.911 19.6508C166.919 19.6508 163.887 19.6508 162.632 19.6508ZM170.471 3.64941H165.559C164.044 3.64941 162.894 4.0972 162.24 5.70543L152.807 28.4292H159.471C159.471 28.4292 160.568 25.3707 160.803 24.712C161.534 24.712 168.017 24.712 168.957 24.712C169.139 25.582 169.715 28.4292 169.715 28.4292H175.595L170.471 3.64941Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.516 3.64941L113.296 20.5471L112.617 17.12C111.467 13.1657 107.861 8.86934 103.837 6.73309L109.533 28.4032H116.249L126.231 3.64941H119.516Z",
    fill: "#9F72DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.521 3.64941H97.3037L97.1992 4.1501C105.169 6.20647 110.448 11.1633 112.617 17.1211L110.396 5.73241C110.03 4.14975 108.906 3.70162 107.521 3.64941Z",
    fill: "#9F72DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_13333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5574,
    height: 25.7586,
    fill: "white",
    transform: "translate(9.5994 3.2002)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_95_13333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.3956,
    height: 25.5986,
    fill: "white",
    transform: "translate(97.1991 3.2002)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogos);
export default __webpack_public_path__ + "static/media/visaLogos.1dd2ec26d07124925d6af7240f1379df.svg";
export { ForwardRef as ReactComponent };